import { formatCurrency } from "./formatCurrency";
import type { ReportCell, ReportColumnFormat } from "../types/reports";

export function formatReportCell(format: ReportColumnFormat, cell: ReportCell | undefined): string {
  if (cell === undefined || cell === "not_applicable") return "-";
  if (cell === "unavailable") return "n/a";
  if (format === "rate") return `${(cell * 100).toFixed(2)}%`;
  if (format === "usd") return formatCurrency(cell, "usd", false);
  return cell.toLocaleString("en-US");
}
